/* unplugin-vue-components disabled */import script from "./ArticleContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleContent.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleContent.vue?vue&type=style&index=0&id=e80a3ee2&lang=css"
import "./ArticleContent.vue?vue&type=style&index=1&id=e80a3ee2&lang=scss"

const __exports__ = script;

export default __exports__